export function assetUrl(path: string): string {
  return `${import.meta.env.VITE_ASSETS_URL}/${path}`;
}
